"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ListModule = _interopRequireDefault(require("../../Module/ListModule"));

var _ModuleBase = _interopRequireDefault(require("../../Module/ModuleBase"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: theme.spacing(2),
    "& + $root": {
      borderTop: "1px solid",
      borderColor: theme.palette.divider,
      marginTop: theme.spacing(1)
    },
    "& $root": {
      border: "1px solid",
      backgroundColor: theme.palette.background.default,
      borderColor: theme.palette.divider,
      boxShadow: "none"
    }
  },
  header: {},
  body: {
    marginTop: theme.spacing(2)
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    fontSize: "18px",
    fontWeight: "normal",
    letterSpacing: 0
  }
}));

const PrimusModulePreview = ({
  title,
  description,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement(_Paper.default, {
    className: classes.root,
    square: true,
    elevation: 1
  }, children);
};

var _default = PrimusModulePreview;
exports.default = _default;
module.exports = exports.default;